/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Freight_Status_CompanyInputs */

const vi_order_freight_status_company = /** @type {(inputs: Order_Freight_Status_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi trả cước`)
};

/**

* @param {Order_Freight_Status_CompanyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_freight_status_company = /** @type {((inputs?: Order_Freight_Status_CompanyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Freight_Status_CompanyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_freight_status_company(inputs)
});